import { TLanguages } from 'src/_i18n/types';

export const UPDATE_CONNECTION = 'UPDATE_CONNECTION';
export const UPDATE_LANGUAGE = 'UPDATE_LANGUAGE';
export const SW_INIT = 'SW_INIT';
export const SW_UPDATE = 'SW_UPDATE';

export interface IReducerConfigState {
  lang: TLanguages;
  connected: boolean;
  serviceWorkerInitialized: boolean;
  serviceWorkerRegistration?: ServiceWorkerRegistration;
  serviceWorkerUpdated: boolean;
}

export interface IUpdateConnection {
  type: typeof UPDATE_CONNECTION;
  payload: boolean;
}

export interface IUpdateLanguage {
  type: typeof UPDATE_LANGUAGE;
  payload: TLanguages;
}

export interface ISwInit {
  type: typeof SW_INIT;
}

export interface ISwUpdate {
  type: typeof SW_UPDATE;
  payload: ServiceWorkerRegistration;
}

export type ConfigActionTypes =
  | IUpdateConnection
  | IUpdateLanguage
  | ISwInit
  | ISwUpdate;
